const StopClickPropagation = {
  mounted() {
    this.eventListener = (event) => {
      event.stopPropagation()
    }

    this.el.addEventListener("click", this.eventListener)
  },

  destroyed() {
    this.el.removeEventListener("click", this.eventListener)
  },
}

export { StopClickPropagation }
